import { action, makeObservable, observable } from 'mobx';
import { FormStore } from '@roc/feature-app-core';
import { AIDocType } from '../../../constants';
import { ReviewLogStore } from '@roc/feature-ai-docs-review';

const REQUIRED_MESSAGE = 'This field is required';

const form = {
  fields: {
    pctOwnership: {
      value: '',
      error: null,
      rule: '',
    },
    roleInEntity: {
      value: '',
      error: null,
      rule: '',
    },
    authSignatory: {
      value: '',
      error: null,
      rule: '',
    },
    personalGuarantor: {
      value: '',
      error: null,
      rule: '',
    },
    stateForSigning: {
      value: '',
      error: null,
      rule: '',
    },
    countyForSigning: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: true,
    error: null,
  },
};

export class EditEntityBorrowerStore extends FormStore {
  open = false;
  entityBorrower: any;
  reviewLogStore: ReviewLogStore;

  constructor(globalStore, reviewLogStore: ReviewLogStore) {
    super(form, globalStore);
    this.reviewLogStore = reviewLogStore;
    makeObservable(this, {
      open: observable,
      openDialog: action,
      closeDialog: action,
    });
  }

  openDialog = entityBorrower => {
    this.reset();
    this.entityBorrower = entityBorrower;
    this.loadForm(entityBorrower);
    this.open = true;
  };

  onFieldChange(field: any, value: any): void {
    const eventPayload = {
      docType: AIDocType.ENTITY,
      mapping: 'data',
      borrowerId: this.entityBorrower.borrowerId,
      itemDisplayName: field,
      value
    }
    this.reviewLogStore.addEvent(eventPayload);
    super.onFieldChange(field, value);
  }

  closeDialog = () => {
    this.open = false;
  };
}

export default EditEntityBorrowerStore;
